
import React, { useEffect, useState } from 'react';

import axios from "axios";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';

import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export default function NutriTable(props) {

    const mealName = props.showNutrition;
    const zusatzstoffe = props.showZusatzstoffe;
    const zutaten = props.showZutaten;
    const nutriData = props.nutriData



    console.log("mealName", props.showNutrition)


    const [meals, setMeals] = useState();
    const [bild, setBild] = useState(null);

    const [nutri, setNutri] = useState("");
    const [showResult, setShowResult] = useState(null);
    // const [zutaten, setZutaten] = useState('');
    // const [zusatzstoffe, setZusatzstoffe] = useState(null);

    useEffect(() => {
        let config = {
            method: "get",
            url: "https://intranet-backend.procuratio.com/tablet/lmiv.php",

            headers: {
                Accept: "application/json"
            }
        };

        axios(config)
            .then(function (response) {
                setNutri(response.data);


            })
            .catch(function (error) {
                console.log(error);
            });
    }, []);


    useEffect(() => { console.log(bild) }, [bild]);
    useEffect(() => { console.log(zutaten) }, [zutaten]);

    useEffect(() => { console.log(zusatzstoffe) }, [zusatzstoffe]);




    function createData(name, kcal, fett, gesFett, kohl, zucker, ei, salz) {

        return { name, kcal, fett, gesFett, kohl, zucker, ei, salz };
    }

    const rows = [

        createData('Brennwert in kcal'),
        createData('Fett'),
        createData('gesättigte Fettsäuren'),
        createData('Kohlenhydrate'),
        createData('Zucker'),
        createData('Eiweiß'),
        createData('Salz'),
        createData('Zutaten'),
        createData('Zuzatzstoffe'),

    ];



    return (
        <div className='scroll'>



            <TableContainer style={{ width: '35vw'}} >

                <img style={{ width: '15vw', padding: 20 }} src={nutriData.bild} alt="" />

                <h1>{nutriData.bezeichnung}</h1>
                <h2>Nährwerte je 100g: </h2>
                <table >
                 
                    <tr>
                        <td>Brennwert in kcal / kJ: </td>
                        <td style={{ padding: 10}}>{nutriData.kcal}</td>

                    </tr>
                    <tr>
                        <td>Fett in g: </td>
                        <td style={{ padding: 10 }}> {nutriData.fett}</td>

                    </tr>
                    <tr>
                        <td>davon gesättigte Fettsäuren in g: </td>
                        <td style={{ padding: 10 }}>{nutriData.gesfett}</td>

                    </tr>
                    <tr>
                        <td>Kohlenhydrate in g: </td>
                        <td style={{ padding: 10 }}>{nutriData.Kohlenhydrate}</td>

                    </tr>
                    <tr>
                        <td>davon Zucker in g: </td>
                        <td style={{ padding: 10 }}>{nutriData.Zucker}</td>

                    </tr>
                    <tr>
                        <td>Eiweiss in g: </td>
                        <td style={{ padding: 10 }}>{nutriData.eiweiss}</td>

                    </tr>
                    <tr>
                        <td>Salz in g: </td>
                        <td style={{ padding: 10 }}> {nutriData.salz}</td>

                    </tr>
                    </table>
                    {nutriData.zutaten &&
                                    nutriData.zutaten!='' 
                                    ?    <>
                                    <h2>Zutaten: </h2>
                                                            <p style={{ padding: 10 }}> {nutriData.zutaten}</p>
                                    </> :''
                                    }
                        
                        <h2>Zusatzstoffe und Allergene: </h2>
                        <p style={{ padding: 10 }}> {nutriData.zusatzstoffe}</p>
                                    <p style={{ padding: 10 , fontSize: '9px'}}>Bei der Zubereitung der Speisen und Gerichte verwenden wir Allergie/Lebensmittelunverträglichkeit auslösende(n) Stoff(e) als Zutat(en). Diese sind in der Aufstellung angegeben. Trotz größtmöglicher Sorgfalt können unsere Lieferanten und wir jedoch nicht ausschließen, dass sich technisch unvermeidbare Einträge von diesen Allergie/Lebensmittelunverträglichkeit auslösende(n) Stoff(e) auch in diese Speisen und Gerichte gelangen. Weitere Auskünfte erteilt Ihnen gerne das Servicepersonal.</p>
                 
                
   





            </TableContainer>
            
        </div>
    );
}

